<div class="flex flex-col max-h-[80vh] overflow-y-auto mt-4">
  @for (option of options(); track option; let first = $first) {
    <div
      [class.border-t]="!first"
      [class]="option?.class ?? ''"
      (click)="onClick(option)"
      class="flex flex-row items-center pt-4 pb-4 pl-3 pr-3"
      [ngClass]="{
        'cursor-pointer hover:bg-hover': !option.disabled,
        'cursor-not-allowed text-lighter': option.disabled,
      }"
    >
      @if (option.icon) {
        <div class="flex items-center justify-center mr-3 w-10 h-10">
          <i [ngClass]="option?.icon"></i>
        </div>
      }
      <span [ngClass]="option.disabled ? 'text-lighter' : 'soft-text'">{{
        option?.label
      }}</span>
    </div>
  }
</div>
